function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".instagram_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "instagram_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "instagram_svg__Icons"
}, /*#__PURE__*/React.createElement("path", {
  className: "instagram_svg__cls-1",
  d: "M41 82a41 41 0 1141-41 41 41 0 01-41 41zm0-80a39 39 0 1039 39A39 39 0 0041 2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "instagram_svg__cls-1",
  d: "M52 23H30a7 7 0 00-7 7v22a7 7 0 007 7h22a7 7 0 007-7V30a7 7 0 00-7-7zm2 4.15h.79v6.1h-6.08v-6.1zM35.87 37.31a6.32 6.32 0 11-1.2 3.69 6.33 6.33 0 011.2-3.69zM55.5 52a3.45 3.45 0 01-3.5 3.48H30A3.45 3.45 0 0126.51 52V37.31h5.37a9.84 9.84 0 1018.24 0h5.38z"
})));

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 82"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MiA4MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5JbnN0YWdyYW08L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJJY29ucyI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDEsODJBNDEsNDEsMCwxLDEsODIsNDEsNDEsNDEsMCwwLDEsNDEsODJaTTQxLDJBMzksMzksMCwxLDAsODAsNDEsMzksMzksMCwwLDAsNDEsMloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01MiwyM0gzMGE3LDcsMCwwLDAtNyw3VjUyYTcsNywwLDAsMCw3LDdINTJhNyw3LDAsMCwwLDctN1YzMEE3LDcsMCwwLDAsNTIsMjNabTIsNC4xNWguNzl2Ni4xbC02LjA4LDAsMC02LjFaTTM1Ljg3LDM3LjMxQTYuMzIsNi4zMiwwLDEsMSwzNC42Nyw0MSw2LjMzLDYuMzMsMCwwLDEsMzUuODcsMzcuMzFaTTU1LjUsNTJBMy40NSwzLjQ1LDAsMCwxLDUyLDU1LjQ4SDMwQTMuNDUsMy40NSwwLDAsMSwyNi41MSw1MlYzNy4zMWg1LjM3YTkuODQsOS44NCwwLDEsMCwxOC4yNCwwSDU1LjVaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgInstagram as ReactComponent };